import { copy } from "../copy.ts";

/**
 * The post-delete report, shared by the two screens that can delete a place.
 *
 * Not in `copy.ts` (that file is outside these screens' reach). One toast, one sentence per fact:
 * the Toast component holds a single message, so three sequential `showToast` calls would leave only
 * the last one visible and the other two would never be read. The trip count is deliberately said as
 * a statement rather than a question — it is only knowable from the delete's own response, so by the
 * time this line is shown the loss has already happened, and pretending the user could still choose
 * would be a lie about the moment.
 */
export function deleteReport(
  name: string,
  response: { affected_itinerary_items: number; orphaned_areas: string[] },
): string {
  const parts: string[] = [copy.places.removed];
  if (response.affected_itinerary_items > 0) {
    parts.push(`${String(response.affected_itinerary_items)} mục lịch trình đã mất “${name}”.`);
  }
  if (response.orphaned_areas.length > 0) {
    parts.push(copy.places.orphanedAreas(response.orphaned_areas.join(", ")));
  }
  return parts.join(" ");
}
